import React from "react";
import { MobileOtpEnter } from "../../components/header/components/mobile-otp-enter";
import { useLocation } from "react-router-dom";
export default function MobileLoginPage() {
    const { state } = useLocation();
    console.log('state', state)
    return <MobileOtpEnter redirection={state?.redirection} />
}